const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.alumnoCursado = model;
  },

  setModels(state, data) {
    state.alumnoCursados = data.models;
    state.pagination = data.headers;
    state.pagination.totalCount = +data.headers["x-pagination-total-count"];
  },

  addModel(state, model) {
    state.alumnoCursados.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.alumnoCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.alumnoCursados.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
